export default __webpack_public_path__ + "static/media/black.5d3ffe3f.jpg";